/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import { verifyPolicy } from '@/services/api/buy/policy';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
  async verify(unset, policyId) {
    const { data } = await verifyPolicy(policyId);
    return data;
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
